<template>
  <div 
    class="mt-4">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div v-if="message.select === 'delete'">
                  Anda Berhasil Menghapus Data
                </div>
                <div v-else>
                  Anda Berhasil Mengubah Data
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- <v-snackbar v-if="Object.keys(verifikasi_add).length > 0 && dialog.addvarifikasi" centered :color="verifikasi_add.results.data.color" v-model="dialog.addvarifikasi">
          
          <span 
            class="body-1 font-weight-light white--text"
            v-html="verifikasi_add.message">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.addvarifikasi = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar> -->
        <v-dialog v-model="dialog.addvarifikasi" width="500">
          <v-card
            color="transparent"
            class="white--text"
            flat
            v-if="Object.keys(verifikasi_add).length > 0">
            <v-alert :type="verifikasi_add.results.data.color" class="white--text">
              {{ verifikasi_add.message }}
            </v-alert>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                <div class="body-2 mb-2">
                  No Transaksi
                </div>
                <v-text-field
                  rounded
                  dense
                  
                  filled
                  clearable
                  placeholder="Tulis No Transaksi"
                  hide-details
  
                  :color="set_color"
                  v-model="filter.transaction"

                  style="border-radius: 10px;">
                </v-text-field>

                <div class="body-2 mb-2 mt-4">
                  Ref
                </div>
                <v-text-field
                  rounded
                  dense
                  filled
                  clearable
                  
                  hide-details
                  placeholder="Tulis Ref"
  
                  :color="set_color"
                  v-model="filter.ref"

                  style="border-radius: 10px;">
                </v-text-field>

                <div class="body-2 mb-2 mt-4">
                  Nama Project
                </div>
                <v-autocomplete
                  filled
                  rounded
                  dense
  
                  :color="set_color"
                  placeholder="Pilih Project"
  
                  hide-details
                  clearable
                  item-text="name"
                  item-value="name"
                  :items="project"
  
                  v-model="filter.project_name"
                  style="border-radius: 10px;">
                </v-autocomplete>

                <div class="body-2 mb-2 mt-4">
                  Nama Posisi
                </div>
                <v-autocomplete
                  filled
                  rounded
                  dense
  
                  :color="set_color"
                  placeholder="Pilih Posisi"
  
                  hide-details
                  clearable
                  :items="[
                    'Internal', 'Public'
                  ]"
  
                  v-model="filter.posisi"
                  style="border-radius: 10px;">
                </v-autocomplete>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; toFilter();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ template.name }}</b>?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.listCoa"
          @keydown.esc="dialog.listCoa = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Pilih Chart of Account (CoA)
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.listCoa = false; dialog.fullscreen = false; process.form = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <!-- <ValidationProvider
                    name="Nama Kategori" 
                    rules="required" 
                    v-slot="{ errors, valid }"> -->
                    <div class="body-2 mb-2">
                      <!-- <span class="red--text">*</span> -->
                      Nama Chart of Account (CoA)
                    </div>

                    <v-autocomplete
                      
                      filled
                      rounded
                      dense
  
                      :color="set_color"
                      placeholder="Pilih CoA"
  
                      hide-details
                      clearable
                      item-text="name"
                      item-value="id"
                      :items="dialog.template ? item_coa_jurnal : item"
                      multiple
                      return-object
  
                      v-model="selected_coa"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <!-- <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="selected_coa !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template> -->
                    </v-autocomplete>
                  <!-- </ValidationProvider> -->
                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="saveItem()"
                :loading="process.form"
                :disabled="selected_coa.length < 1 || process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.listCoa = false; process.form = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.listDivisi"
          @keydown.esc="dialog.listDivisi = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Pilih Divisi
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.listDivisi = false; dialog.fullscreen = false; process.form = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <!-- <ValidationProvider
                    name="Nama Kategori" 
                    rules="required" 
                    v-slot="{ errors, valid }"> -->
                    <div class="body-2 mb-2">
                      <!-- <span class="red--text">*</span> -->
                      Nama Divisi
                    </div>

                    <v-autocomplete
                      
                      filled
                      rounded
                      dense
  
                      :color="set_color"
                      placeholder="Pilih Divisi"
  
                      hide-details
                      clearable
                      item-text="name"
                      item-value="id"
                      :items="divisi"
                      multiple
                      return-object
  
                      v-model="selected_divisi"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <!-- <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="selected_coa !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template> -->
                    </v-autocomplete>
                  <!-- </ValidationProvider> -->
                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="saveDivisi()"
                :loading="process.form"
                :disabled="selected_divisi.length < 1 || process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.listDivisi = false; process.form = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.titleJurnal"
          @keydown.esc="dialog.titleJurnal = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Simpan Template Jurnal
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.titleJurnal = false; dialog.fullscreen = false; process.form = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="titleJurnal">
                <v-form>
                  <ValidationProvider
                    name="Nama Jurnal" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nama Jurnal
                    </div>

                    <v-text-field
                      v-on:keyup.enter.prevent="save()"
                      
                      rounded
                      dense
                      outlined
                      hide-details
  
                      :color="set_color"
                      placeholder="Nama Jurnal"
  
                      v-model="title_jurnal"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="title_jurnal !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="SaveJurnal()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.titleJurnal = false; process.form = false; dialog.fullscreen = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.form"
          width="calc(100vw - 100px)"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Ubah atau Hapus Jurnal dengan No Transaksi <b class="font-weight-bold black--text">{{ selected_jurnal.number }}</b>
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>
            <v-card-text
              v-if="process.detail" 
              class="pb-0 my-4" 
              style="height: 600px; display: flex; align-items: center; justify-content: center;">
              <div class="text-center">
                <div class="mb-4 title">
                  Mohon Tunggu . . .
                </div>

                <v-progress-linear
                  :color="set_color"
                  indeterminate
                  rounded
                  height="10">
                </v-progress-linear>
              </div>
            </v-card-text>

            <v-card-text v-if="!process.detail"
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col class="py-0" cols="4">
                      <div class="mb-2">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          Ref
                        </div>
                        <div>
                          <ValidationProvider
                            :name="`Ref`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              rounded
                              dense
                              autofocus
                              outlined
                              hide-details
        
                              :color="set_color"
                              placeholder="Ref"
                              :error-messages="errors"
        
                              v-model="form.ref"
                              
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.ref !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="mb-2 font_weight_600 fs-13 black_one">
                        Catatan Transaksi
                      </div>
                      <ValidationProvider
                        :name="`Catatan`" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <v-textarea
                          v-on:keyup.enter="save()"
                          
                          rounded
                          dense
                          outlined
                          hide-details
                          rows="1"
    
                          :color="set_color"
                          placeholder="Catatan"
                          :error-messages="errors"
    
                          v-model="form.note"
                          
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="form.note !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </v-col>
                    <v-col class="py-0" cols="4">
                      <div class="mb-2 font_weight_600 fs-13 black_one">
                        Project
                      </div>
                      <v-autocomplete
                        v-on:keydown.enter.prevent="save()"
                        
                        outlined
                        rounded
                        dense

                        :color="set_color"
                        v-on:change="changeVendor()"
                        placeholder="Pilih Project"

                        hide-details
                        clearable
                        item-text="name"
                        item-value="id"
                        :items="project"

                        v-model="form.project_id"
                        style="border-radius: 10px;">
                      </v-autocomplete>

                      <div>
                        <div class="mb-2 font_weight_600 fs-13 black_one mt-3">
                          Vendor
                        </div>
                        <v-autocomplete
                          v-on:keydown.enter.prevent="save()"
                          
                          outlined
                          rounded
                          dense

                          :color="set_color"
                          :readonly="form.project_id === '' || form.project_id === null"
                          :disabled="form.project_id === '' || form.project_id === null"
                          placeholder="Pilih Vendor"
                          v-on:change="form.vendor_name = vendor.find(x => x.id === form.vendor_id).name"

                          hide-details
                          clearable
                          item-text="name"
                          item-value="id"
                          :items="vendor"

                          v-model="form.vendor_id"
                          style="border-radius: 10px;">
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col class="py-0" cols="4">
                      <v-row>
                        <v-col cols="12" md="6" class="pt-0 pb-0 pl-0">

                          <div>
                            <div class="mb-2 font_weight_600 fs-13 black_one">
                              Tanggal
                            </div>
                            <!-- <v-menu
                              v-model="mrnu3"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                              >
                              <template v-slot:activator="{ on, attrs }"> -->
                                <ValidationProvider 
                                  :name="`Tanggal`" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-model="form.date"
                                    
                                    v-on:keyup.enter="save()"
                                    
                                    
                                    outlined
                                    dense
                                    
                                    :color="set_color"
                                    placeholder="Tanggal"
              
                                    hide-details
                                  
              
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    type="date"
                                    locale="id"
                                    >
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
                                      
                                      <div v-if="form.date !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              <!-- </template>
                              <v-date-picker
                                v-model="form.date"
                                @input="mrnu3 = false"
                              ></v-date-picker>
                            </v-menu> -->
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-0 pb-0 pr-0">
                          
                          <div>
                            <div class="mb-2 font_weight_600 fs-13 black_one">
                              Waktu
                            </div>
                            <!-- <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }"> -->
                                <ValidationProvider 
                                  :name="`Waktu}`" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-model="form.time"
                                    
                                    v-on:keyup.enter="save()"
                                    
                                    hide-details
                                    outlined
                                    dense
                                    
                                    :color="set_color"
                                    placeholder="Waktu"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    type="time"
                                    locale="id"
                                    >
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
                                      
                                      <div v-if="form.time !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              <!-- </template>
                              <v-time-picker
                                v-model="form.time"
                                format="24hr"
                                @input="menu1 = false"
                              ></v-time-picker>
                            </v-menu> -->
    
                          </div>
                        </v-col>
                      </v-row>


                      <div>
                        <div class="mb-2 font_weight_600 fs-13 black_one mt-3">
                          Posisi Jurnal
                        </div>
                        <v-row>
                          <v-col cols="12" md="6" class="py-0">
                            <v-checkbox v-model="form.internal_bool" hide-details dense class="mt-0 pt-0">
                              <template v-slot:label>
                                <div class="black_one fs-15">
                                  Jurnal Internal
                                </div>
                              </template>
                            </v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" class="py-0">
                            <v-checkbox v-model="form.public_bool" hide-details dense class="mt-0 pt-0">
                              <template v-slot:label>
                                <div class="black_one fs-15">
                                  Jurnal Public
                                </div>
                              </template>
                            </v-checkbox>
                          </v-col>
                        </v-row>
                      </div>


                      <div class="mb-2 font_weight_600 fs-13 black_one mt-2">
                        Catatan Project
                      </div>
                      <v-textarea
                        v-on:keyup.enter.prevent="save()"
                        
                        outlined
                        rounded
                        dense
                        hide-details
                        rows="1"

                        :color="set_color"
                        placeholder="Catatan Project"
                        v-model="form.project_note"
                        style="border-radius: 10px;">
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-6"></v-divider>
                  <v-row>
                    <v-col cols="12">
                      <div class="d-flex align-center">
                        <div class=" px-2" style="width: 100%;">
                          <div class="fs-18 font-weight-bold black_one">
                            Data Chart of Account (CoA)
                          </div>
  
                          <div class="mt-2">
                            <v-btn
                              elevation="0"
                              :disabled="process.form || form.can_deleted_bool === false"
                              @click="dialog.listCoa = true; resetItem();"
                              color="#240087"
                              
                              class="fs-11 white--text text-capitalize border-radius">
                              <v-icon
                                size="18">
                                mdi-plus
                              </v-icon>
  
                              <span
                                class="ml-2">
                                Tambah 
                              </span>
                            </v-btn>
                          </div>
                        </div>
                        <div class="ml-auto d-flex text-right pr-5" style="width: 100%; justify-content: end;">
                          <div style="" class="text-right px-4 d-flex">
                            <div class="black_one font_weight_600">
                              Total Debit: 
                            </div>
                            <div class="font_weight_600 fs-20 ml-2" :class="add_total_debit !== add_total_kredit ? 'red--text' : 'black_one'">
                              {{ add_total_debit | price }}
                            </div>
                          </div>
                          <div style="" class="ml-5 d-flex">
                            <div class="black_one font_weight_600">
                              Total Kredit: 
                            </div>
                            <div class="font_weight_600 fs-20 ml-2" :class="add_total_debit !== add_total_kredit ? 'red--text' : 'black_one'">
                              {{ add_total_kredit | price }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <v-card flat>
                        <v-card-text class="py-0 px-2">

                          <div class="view mt-1">
                            <div class="wrapper_add">
                              <table style="border: 1px solid #ededed; width: 100%;" class="table">
                                <tr>
                                  <th style="font-size: 14px; z-index: 1; width: 50px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Aksi</th>
                                  <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">No Akun</th>
                                  <th style="font-size: 14px; z-index: 1; width: 210px; min-width: 210px; max-width: 210px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Akun</th>
                                  <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                    <div class="d-flex align-center">
                                      <div>
                                        Debit
                                      </div>
                                      <!-- <div class="ml-auto">
                                        {{ add_total_debit | price }}
                                      </div> -->
                                    </div>
                                  </th>
                                  <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                    <div class="d-flex align-center">
                                      <div>
                                        Kredit
                                      </div>
                                      <!-- <div class="ml-auto">
                                        {{ add_total_kredit | price }}
                                      </div> -->
                                    </div>
                                  </th>
                                </tr>
                                <tr v-for="(item, index) in form.items" :key="index" @click="selected.add = (((`100${index}`) + index) + (index+1))" :class="selected.add === (((`100${index}`) + index) + (index+1)) ? 'selected' : ''">
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 50px; min-width: 50px; max-width: 50px; text-align: center;">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          v-bind="attrs"
                                          v-on="on"
                                          min-width="36"
                                          :disabled="process.form || form.can_deleted_bool === false"
                                          rounded
                                          @click="form.items.splice(index, 1);"
                                          color="red"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon small>mdi-trash-can-outline</v-icon>
                                          
                                        </v-btn>
                                      </template>
              
                                      <span>Hapus</span>
                                    </v-tooltip>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 150px; min-width: 150; max-width: 150px; text-align: center;">{{ item.number }}</td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; width: 210px; min-width: 210px; max-width: 210px; border-left: none; padding: 8px 12px; text-align: left;">
                                    {{ item.name }}
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                                    <ValidationProvider
                                      :name="`Debit ${item.name}`" 
                                      :rules="`min_value:0`" 
                                      v-slot="{ errors }">
                                      <v-currency-field
                                            
                                        
                                        rounded
                                        dense
                                        outlined
                                        hide-details
                  
                                        :color="set_color"
                                        placeholder="Debit"
                                        :error-messages="errors"
    
                                        @input="changeTotal()"
                  
                                        v-model="item.debit"
                                        
                                        required
                                        style="border-radius: 10px;">
                                        <template v-slot:append-outer>
                                          <div v-if="errors.length > 0">
                                            <v-tooltip top color="#ff5252">
                                              <template v-slot:activator="{ on }">
                                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                              </template>
                                              
                                              {{ errors[0] }}
                                            </v-tooltip>
                                          </div>
                                          
                                          <!-- <div v-if="item.debit !== '' && valid">
                                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                                          </div> -->
                                        </template>
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                                    <ValidationProvider
                                      :name="`Kredit ${item.name}`" 
                                      :rules="`min_value:0`" 
                                      v-slot="{ errors }">
                                      <v-currency-field
                                            
                                        
                                        rounded
                                        dense
                                        outlined
                                        hide-details
                  
                                        :color="set_color"
                                        placeholder="Kredit"
                                        :error-messages="errors"
                                        @input="changeTotal()"
    
                                        
                  
                                        v-model="item.kredit"
                                        
                                        required
                                        style="border-radius: 10px;">
                                        <template v-slot:append-outer>
                                          <div v-if="errors.length > 0">
                                            <v-tooltip top color="#ff5252">
                                              <template v-slot:activator="{ on }">
                                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                              </template>
                                              
                                              {{ errors[0] }}
                                            </v-tooltip>
                                          </div>
                                          
                                          <!-- <div v-if="item.kredit !== '' && valid">
                                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                                          </div> -->
                                        </template>
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </td>
                                </tr>
                              </table>
                              <v-card-text
                                v-if="form.items.length === 0"
                                class="pb-0 my-4" style="height: calc( 100vh - 800px ); display: flex; align-items: center; justify-content: center;">
                                <div class="text-center">
                                  <v-img 
                                    class="mx-auto"
                                    contain
                                    alt="vuetify"
                                    :width="90"
                                    :height="90"
                                    :src="require('@/assets/image/empty.png')">
                                    <!-- <template v-slot:placeholder>
                                      <v-row
                                        class=" "
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template> -->
                                  </v-img>
                                  <div class="mt-3 fs-16">
                                    Belum Ada CoA
                                  </div>
                                </div>
                              </v-card-text>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-6"></v-divider>
                  <v-row>
                    <v-col cols="12">
                      <div class="d-flex align-center">
                        <div class=" px-2" style="width: 100%;">
                          <div class="fs-18 font-weight-bold black_one">
                            Data Divisi
                          </div>
  
                          <div class="mt-2">
                            <v-btn
                              elevation="0"
                              :disabled="process.form || form.can_deleted_bool === false"
                              @click="dialog.listDivisi = true; resetDivisi();"
                              color="#240087"
                              
                              class="fs-11 white--text text-capitalize border-radius">
                              <v-icon
                                size="18">
                                mdi-plus
                              </v-icon>
  
                              <span
                                class="ml-2">
                                Tambah 
                              </span>
                            </v-btn>
                          </div>
                        </div>
                      </div>

                      <v-card flat>
                        <v-card-text class="py-0 px-2">

                          <div class="view mt-1">
                            <div class="wrapper_add">
                              <table style="border: 1px solid #ededed; width: 100%;" class="table">
                                <tr>
                                  <th style="font-size: 14px; z-index: 1; width: 120px; min-width: 120px; max-width: 120px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Aksi</th>
                                  <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Divisi</th>
                                  <th style="font-size: 14px; z-index: 1; width: 300px; min-width: 300px; max-width: 300px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Kategori</th>
                                  <th style="font-size: 14px; z-index: 1; width: 200px; min-width: 200px; max-width: 200px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                    <div class="d-flex align-center">
                                      <div>
                                        Nominal
                                      </div>
                                      <!-- <div class="ml-auto">
                                        {{ add_total_debit | price }}
                                      </div> -->
                                    </div>
                                  </th>
                                  <th style="font-size: 14px; z-index: 1; width: 100%; min-width: 100%; max-width: 100%; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                    Note
                                  </th>
                                </tr>
                              </table>
                              <div class="d-flex align-center" v-for="(item, index) in form.unit_array" :key="index" style="width: 100%; border-bottom: 1px solid #eee; border-left: 1px solid #eee; border-right: 1px solid #eee; height: 100%;">
                                <div style="width: 120px; min-width: 120px; padding: 8px 12px;" class="text-center">
                                  <div>
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          v-bind="attrs"
                                          v-on="on"
                                          min-width="32"
                                          min-height="32"
                                          height="32"
                                          small
                                          :disabled="process.form || form.can_deleted_bool === false"
                                          rounded
                                          @click="form.unit_array.splice(index, 1);"
                                          color="red"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon small>mdi-trash-can-outline</v-icon>
                                          
                                        </v-btn>
                                      </template>
              
                                      <span>Hapus</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          v-bind="attrs"
                                          v-on="on"
                                          min-width="32"
                                          min-height="32"
                                          height="32"
                                          small
                                          rounded
                                          :disabled="item.category_array.length === item.category_selected.length || process.form || form.can_deleted_bool === false"
                                          @click="item.category_array.length === item.category_selected.length ? false : item.category_selected.push({ id: '', balance: 0, title: '', selected_bool: true, note: '' });"
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon small>mdi-plus-circle</v-icon>
                                          
                                        </v-btn>
                                      </template>
              
                                      <span>Kategori</span>
                                    </v-tooltip>
                                  </div>
                                </div>
                                <div style="width: 150px; min-width: 150px; padding: 8px 12px; font-size: 12px; border-left: 1px solid #eee;">
                                  {{ item.name }}
                                </div>
                                <div style="width: 100%;">
                                  <div class="d-flex" v-for="(i, l) in item.category_selected" :key="l">
                                    <div style="width: 300px; min-width: 300px; padding: 8px 12px; border-left: 1px solid #eee; border-right: 1px solid #eee;">
                                      <ValidationProvider
                                        :name="`Kategori ${item.name}`" 
                                        :rules="`required`" 
                                        v-slot="{ errors }">
                                        <v-autocomplete
                                          v-on:keydown.enter.prevent="save()"
                                          
                                          outlined
                                          rounded
                                          dense
                                          hide-details
                                          clearable
                                          :color="set_color"
                                          item-text="title"
                                          item-value="id"
                                          calss="fs-12"
                                          :items="item.category_array.filter(x => !item.category_selected.map(x => (x.id !== i.id ? x.id : '')).includes(x.id))"
                                          v-on:change="i.title = item.category_array.find(x => x.id === i.id).title;"
                                          v-model="i.id"
                                          style="border-radius: 6px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
                                            
                                            <!-- <div v-if="item.category !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div> -->
                                          </template>
                                        </v-autocomplete> 
                                      </ValidationProvider>
                                    </div>
                                    <div style="width: 200px; min-width: 200px; padding: 8px 12px; border-left: 1px solid #eee;">
                                      <ValidationProvider
                                        :name="`Nominal ${item.name}`" 
                                        :rules="`min_value:0`" 
                                        v-slot="{ errors }">
                                        <v-currency-field
                                              
                                          
                                          rounded
                                          dense
                                          outlined
                                          hide-details
                    
                                          :color="set_color"
                                          placeholder="Nominal"
                                          :error-messages="errors"
                    
                                          v-model="i.balance"
                                          
                                          required
                                          style="border-radius: 6px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
                                            
                                            <!-- <div v-if="item.nominal !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div> -->
                                          </template>
                                        </v-currency-field>
                                      </ValidationProvider>
                                    </div>
                                    <div style="width: 100%; padding: 8px 12px; border-left: 1px solid #eee;">
                                      <v-textarea
                                        v-on:keyup.enter.prevent="save()"
                                        
                                        outlined
                                        rounded
                                        dense
                                        hide-details
                                        rows="1"
                                        :color="set_color"
                                        placeholder="Catatan"
                                        v-model="i.note"
                                        style="border-radius: 6px;">
                                      </v-textarea>
                                    </div>
                                  </div>
                                </div>

                              </div>
                              <v-card-text
                                v-if="form.unit_array.length === 0"
                                class="pb-0 my-4" style="height: calc( 100vh - 800px ); display: flex; align-items: center; justify-content: center;">
                                <div class="text-center">
                                  <v-img 
                                    class="mx-auto"
                                    contain
                                    alt="vuetify"
                                    :width="90"
                                    :height="90"
                                    :src="require('@/assets/image/empty.png')">
                                    <!-- <template v-slot:placeholder>
                                      <v-row
                                        class=" "
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template> -->
                                  </v-img>
                                  <div class="mt-3 fs-16">
                                    Belum Ada Divisi
                                  </div>
                                </div>
                              </v-card-text>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
            class="mt-2"
            style="border-top: 2px dashed #e0e0e0;"/>
            
            <v-card-actions
            class="pa-4">

              <v-btn
                @click="dialog.delete = true; message.select = 'delete';"
                :disabled="process.form"
                width="120"
                v-if="form.can_deleted_bool === true"
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Hapus
              </v-btn>
              <div v-if="message.error.length > 0"
                class="text-left">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <div v-if="form.can_deleted_bool === false"
                class="text-left">
                <div
                  class="warning--text d-flex align-start">
                  <v-icon size="18" color="orange" style="margin-top: 3px;">mdi-alert-outline</v-icon>
                  
                  <span
                    class="ml-2">
                    {{ form.reason }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="save(); message.select = 'update';"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                v-if="form.can_deleted_bool === true"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Ubah
              </v-btn>

              <v-btn
                @click="dialog.form = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.status"
          @keydown.esc="dialog.status = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="">
            <v-card-title 
              class="d-flex align-center pa-4 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Verifikasi Jurnal

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-4 py-3">
              Apakah Anda yakin ingin <b class="font-weight-bold black_one" v-if="message.status === 'terima'">verifikasi jurnal</b> <b class="font-weight-bold black_one" v-if="message.status === 'tolak'">hapus jurnal</b> ini?

              <!-- <div>
                <ValidationObserver 
                  ref="form">
                  <v-form>

                    <div
                      class="mb-6 mt-5"  v-if="message.status === 'tolak'">
                      <ValidationProvider 
                        name="Alasan" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Alasan
                        </div>

                        <v-textarea
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          rows="3"
                          solo

                          :color="set_color"
                          placeholder="Contoh. Tuliskan alasan disini . . ."


                          v-model="rejected_reason"
                          :error-messages="errors"
                          style="border-radius: 10px;">
                        </v-textarea>
                      </ValidationProvider>
                    </div>
                    

                    <div
                      class="mb-6 mt-5" v-if="message.status === 'terima' && approved_by.length > 0">
                      <ValidationProvider 
                        name="Alasan" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Alasan
                        </div>

                        <v-textarea
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          rows="3"
                          solo

                          :color="set_color"
                          placeholder="Contoh. Tuliskan alasan disini . . ."


                          v-model="approved_reason"
                          :error-messages="errors"
                          style="border-radius: 10px;">
                        </v-textarea>
                      </ValidationProvider>
                    </div>
                    
                  </v-form>
                </ValidationObserver>
              </div> -->

              <div v-if="message.error.length > 0"
                class="text-left mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4 pt-4">
              <v-spacer/>

              <v-btn
                @click="message.status = 'terima'; saveStatus()"
                :loading="process.form && message.status === 'terima'"
                :disabled="process.form"
                v-if="message.status === 'terima'"
                elevation="0"
                color="green"
                width="120"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Yakin
              </v-btn>

              <v-btn
                @click="message.status = 'tolak'; saveStatus()"
                v-if="message.status === 'tolak'"
                :loading="process.form && message.status === 'tolak'"
                :disabled="process.form"
                elevation="0"
                width="120"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text mx-2">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                :disabled="process.form"
                @click="dialog.status = false; dialog.fullscreen = false;"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.template"
          @keydown.esc="dialog.template = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.template"
          width="calc(100vw - 100px)"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Template Jurnal
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.template = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 mt-0 mb-4">
              <v-row>
                <v-col cols="12">
                  <!-- <div class="d-flex"> -->
                    <div class=" px-2" style="width: 100%;">
                      <div class="body-2 mb-2">
                        Judul Template
                      </div>
                      <div v-if="!template.edit" class="d-flex">
                        <v-autocomplete
                          filled
                          rounded
                          dense
      
                          :color="set_color"
                          placeholder="Judul Template"
                          v-on:change="addDetailTemplate()"
      
                          hide-details
                          clearable
                          item-text="name"
                          item-value="id"
                          :items="template.list"
                          v-model="template.id"
    
                          class="mb-6"
                          style="border-radius: 10px; width: 350px; min-width: 350px; max-width: 350px;">
                        </v-autocomplete>
                        <!-- <v-btn
                          @click="toUpdateJurnal()"
                          :loading="process.form"
                          :disabled="process.form"
                          width="120"
                          v-if="template.id !== '' && template.id !== null"
                          elevation="0"
                          color="green"
                          rounded
                          class="body-2 font-weight-bold text-capitalize white--text ml-3">
                          Update Jurnal
                        </v-btn> -->
                        <div v-if="template.id !== '' && template.id !== null" class="ml-3">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                min-width="28"
                                min-height="28"
                                width="38"
                                rounded
                                @click="toUpdateJurnal()"
                                :loading="process.form"
                                :disabled="process.form"
                                color="blue"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="20">mdi-square-edit-outline</v-icon>
                                
                              </v-btn>
                            </template>
    
                            <span>Ubah Jurnal</span>
                          </v-tooltip>
                        </div>
                        <div v-if="template.id !== '' && template.id !== null" class="ml-1">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                min-width="22"
                                min-height="22"
                                width="38"
                                rounded
                                @click="toDeleteJurnal()"
                                :loading="process.form"
                                :disabled="process.form"
                                color="red"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="20">mdi-trash-can-outline</v-icon>
                                
                              </v-btn>
                            </template>
    
                            <span>Hapus</span>
                          </v-tooltip>
                        </div>
                        <!-- <v-btn
                          @click="toDeleteJurnal()"
                          :loading="process.form"
                          :disabled="process.form"
                          width="120"
                          v-if="template.id !== '' && template.id !== null"
                          elevation="0"
                          color="green"
                          rounded
                          class="body-2 font-weight-bold text-capitalize white--text ml-3">
                          Hapus Jurnal
                        </v-btn> -->
                      </div>


                      <div v-if="template.edit">
                        <ValidationObserver 
                          ref="form">
                          <v-form>
                            <div class="mb-6 d-flex">
                              <div>
                                <ValidationProvider
                                  :name="`Judul Template`" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    rounded
                                    dense
                                    outlined
                                    hide-details
              
                                    :color="set_color"
                                    placeholder="Judul Template"
                                    :error-messages="errors"
              
                                    v-model="jurnal_update[0].name"
                                    
                                    required
                                    style="border-radius: 10px; width: 350px; min-width: 350px; max-width: 350px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
                                      
                                      <div v-if="form.ref !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </div>

                              <v-btn
                                @click="dialog.listCoa = true; resetItem();"
                                :loading="process.form"
                                :disabled="process.form"
                                width="120"
                                elevation="0"
                                color="green"
                                rounded
                                class="body-2 font-weight-bold text-capitalize white--text ml-3">
                                Tambah CoA
                              </v-btn>
                            </div>
                          </v-form>
                        </ValidationObserver>
                      </div>
                      
                      
                    </div>
                    <!-- <div class=" ml-auto d-flex">
                      <div style="width: 268px;" class="text-right px-4">
                        <div>
                          Total Debit
                        </div>
                        <div class="font_weight_600 fs-16">
                          {{ add_total_debit }}
                        </div>
                      </div>
                      <div style="width: 268px;">
                        <div>
                          Total Debit
                        </div>
                        <div>
                          {{ add_total_debit }}
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <v-card flat>
                    <v-card-text class="py-0 px-2">

                      <div class="view mt-1">
                        <div class="wrapper_jurnal">
                          <table style="border: 1px solid #ededed; width: 100%;" class="table">
                            <tr>
                              <th style="font-size: 14px; z-index: 1; width: 50px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;" v-if="template.edit">Aksi</th>
                              <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">No Akun</th>
                              <th style="font-size: 14px; z-index: 1; width: 210px; min-width: 210px; max-width: 210px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Akun</th>
                              <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                Debit
                              </th>
                              <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Kredit</th>
                            </tr>
                            <tr v-for="(item, index) in template.edit ? jurnal_update[0].selected : template.selected" :key="index" @click="selected.add = (((`100${index}`) + index) + (index+1))" :class="selected.add === (((`100${index}`) + index) + (index+1)) ? 'selected' : ''">
                              <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 50px; min-width: 50px; max-width: 50px; text-align: center;" v-if="template.edit">
                                <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      min-width="36"
                                      rounded
                                      @click="jurnal_update[0].selected.splice(index, 1);"
                                      color="red"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon small>mdi-trash-can-outline</v-icon>
                                      
                                    </v-btn>
                                  </template>
          
                                  <span>Hapus</span>
                                </v-tooltip>
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 150px; min-width: 150; max-width: 150px; text-align: center;">{{ item.number }}</td>
                              <td style="font-size: 12px; border: 1px solid #ededed; width: 210px; min-width: 210px; max-width: 210px; border-left: none; padding: 8px 12px; text-align: left;">
                                {{ item.name }}
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                                <div v-if="template.edit">
                                  <ValidationProvider
                                    :name="`Debit ${item.name}`" 
                                    :rules="`min_value:0`" 
                                    v-slot="{ errors }">
                                    <v-currency-field
                                          
                                      
                                      rounded
                                      dense
                                      outlined
                                      hide-details
                
                                      :color="set_color"
                                      placeholder="Debit"
                                      :error-messages="errors"
  
                                      v-on:change="changeTotal()"
                
                                      v-model="item.debit"
                                      
                                      required
                                      style="border-radius: 10px;">
                                      <template v-slot:append-outer>
                                        <div v-if="errors.length > 0">
                                          <v-tooltip top color="#ff5252">
                                            <template v-slot:activator="{ on }">
                                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                            </template>
                                            
                                            {{ errors[0] }}
                                          </v-tooltip>
                                        </div>
                                        
                                        <!-- <div v-if="item.debit !== '' && valid">
                                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                                        </div> -->
                                      </template>
                                    </v-currency-field>
                                  </ValidationProvider>
                                </div>
                                <span v-if="!template.edit">{{ item.debit | price }}</span>
                              </td>
                              <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                                <div v-if="template.edit">
                                  <ValidationProvider
                                    :name="`Kredit ${item.name}`" 
                                    :rules="`min_value:0`" 
                                    v-slot="{ errors }">
                                    <v-currency-field
                                          
                                      
                                      rounded
                                      dense
                                      outlined
                                      hide-details
                
                                      :color="set_color"
                                      placeholder="Kredit"
                                      :error-messages="errors"
                                      v-on:change="changeTotal()"
  
                                      
                
                                      v-model="item.kredit"
                                      
                                      required
                                      style="border-radius: 10px;">
                                      <template v-slot:append-outer>
                                        <div v-if="errors.length > 0">
                                          <v-tooltip top color="#ff5252">
                                            <template v-slot:activator="{ on }">
                                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                            </template>
                                            
                                            {{ errors[0] }}
                                          </v-tooltip>
                                        </div>
                                        
                                        <!-- <div v-if="item.kredit !== '' && valid">
                                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                                        </div> -->
                                      </template>
                                    </v-currency-field>
                                  </ValidationProvider>
                                </div>
                                <span v-if="!template.edit">{{ item.kredit | price }}</span>
                              </td>
                            </tr>
                          </table>
                          <v-card-text
                            v-if="template.selected.length === 0"
                            class="pb-0 my-4" style="height: calc( 100vh - 650px ); display: flex; align-items: center; justify-content: center;">
                            <div class="text-center">
                              <v-img 
                                class="mx-auto"
                                contain
                                alt="vuetify"
                                :width="90"
                                :height="90"
                                :src="require('@/assets/image/empty.png')">
                                <!-- <template v-slot:placeholder>
                                  <v-row
                                    class=" "
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-row>
                                </template> -->
                              </v-img>
                              <div class="mt-3 fs-16">
                                Belum Ada Detail
                              </div>
                            </div>
                          </v-card-text>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

            </v-card-text>
            
            <v-divider 
            class="mt-2"
            style="border-top: 2px dashed #e0e0e0;"/>
            
            <v-card-actions
            class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-left mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="addJurnalformTemplate()"
                :loading="process.form"
                :disabled="process.form"
                v-if="!template.edit"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Gunakan
              </v-btn>

              <v-btn
                @click="updateTemplateJurnal()"
                :loading="process.form"
                :disabled="process.form"
                v-if="template.edit"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Update Template Jurnal
              </v-btn>

              <v-btn
                @click="template.edit ? template.edit = false : dialog.template = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.selected_jurnal"
          @keydown.esc="dialog.selected_jurnal = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Pilih No. Transaksi Jurnal
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.selected_jurnal = false; dialog.fullscreen = false; process.form = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <!-- <ValidationProvider
                    name="Nama Kategori" 
                    rules="required" 
                    v-slot="{ errors, valid }"> -->
                    <div class="body-2 mb-2">
                      <!-- <span class="red--text">*</span> -->
                      No. Transaksi
                    </div>

                    <v-autocomplete
                      
                      filled
                      rounded
                      dense
                      :disabled="process.form || process.load"
  
                      :color="set_color"
                      placeholder="Pilih No Transaksi"
  
                      hide-details
                      clearable
                      item-text="number"
                      item-value="id"
                      :items="item_jurnal"
                      return-object
  
                      v-model="selected_jurnal"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <!-- <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="selected_coa !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template> -->
                    </v-autocomplete>
                  <!-- </ValidationProvider> -->
                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="selectedJurnal()"
                :loading="process.form"
                :disabled="selected_jurnal.length < 1 || process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Pilih
              </v-btn>

              <!-- <v-btn
                @click="dialog.selected_jurnal = false; process.form = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Detail Perusahaan

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0" v-if="Object">
              <v-form>
                <v-row>
                  <v-col cols="6">
                    
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.detail = false; dialog.fullscreen = false; ">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        
        <section class="mt-2">
          <v-card
              flat
              color="transparent">
              <div
                class="d-flex align-center px-4">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="22">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/image/grip_menu.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
  
                  <span
                    class="fs-16 black--text ml-2"
                    style="font-weight: 600;">
                    Kelola Jurnal
                  </span>
                </div>
  
                <v-spacer />
  
                <div>
                  <!-- <v-btn
                    to="/category-user/add"
                    color="#4B4B4B"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center"
                    style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                    <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                    
                    <span
                      class="ml-2">
                      Tambah
                    </span>
                  </v-btn> -->
                </div>
              </div>
            </v-card>
  
            <v-row
              justify="start"
              class="pa-4 pb-0 pr-1">
              <!-- <v-col cols="7">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="30">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/image/grip_menu.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
  
                  <span
                    class="title black--text ml-2"
                    style="font-weight: 600;">
                    Jenis Usaha
                  </span>
                </div>
              </v-col> -->
              <v-col
                cols="12"
                md="12"
                class="d-flex align-center pt-1">
  
                <!-- FILTER -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.filter = true">
                        <v-icon size="18">mdi-filter-outline</v-icon>
                      </v-btn>
                    </template>
  
                    <span>
                      Filter
                    </span>
                  </v-tooltip>
                </div> -->
                <v-btn
                  color="#4B4B4B"
                  elevation="0"
                  :disabled="process.load"
                  @click="dialog.selected_jurnal = true; selected_jurnal = {};"
                  class="fs-12 white--text text-capitalize d-flex align-center"
                  style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                  <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                  
                  <span
                    class="ml-2">
                    Pilih Jurnal
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          <!-- <v-card flat style="height: calc(100vh - 80px); display: flex; align-items: center; justify-content: center;">
            <v-btn
              color="#4B4B4B"
              elevation="0"
              :disabled="process.load"
              @click="dialog.selected_jurnal = true; selected_jurnal = {};"
              class="fs-12 white--text text-capitalize d-flex align-center ml-4"
              style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
              <v-icon size="20">mdi-plus-circle-multiple</v-icon>
              
              <span
                class="ml-2">
                Pilih Jurnal
              </span>
            </v-btn>
          </v-card> -->
         
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        tab: 0,
        filter: {
          date: '',
          transaction: '',
          ref: '',
          project_name: '',
          posisi: ''
        },
        selected_filter: {
          transaction: '',
          ref: '',
          project_name: '',
          posisi: ''
        },
        items: [],
        item: [],
        item_coa_jurnal: [],
        title_jurnal: '',
        selected_jurnal: {},
        item_jurnal: [],

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false,
          listCoa: false,
          titleJurnal: false,
          status: false,
          template: false,
          addvarifikasi: false,
          listDivisi: false,
          selected_jurnal: true,
          success: false,
        },
        
        search: '',
        selected_coa: [],
        selected_divisi: [],
        selected:
          { row: 0, add: 0 }
        ,
        template: {
          list: [],
          selected: [],
          id: '',
          form: [],
          edit: false,
          name: ''
        },
        divisi: [],
        jurnal_update : [],
        menu2: false,
        menu1: false,
        mrnu3: false,
        menu: [
          { title: 'Belum Verifikasi', id: 0 },
          { title: 'Sudah Verifikasi', id: 1 }
        ],
        project: [],

        role: [],
        selected_list: [],
        divisi_default: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {},
        total_debit: 0,
        total_kredit: 0,
        add_total_debit: 0,
        add_total_kredit: 0,

        lastIndex: 0,
        limit: 20,

        verifikasi_add: {},

        form: {
          outlet_id: '',
          location_id: '',

          date: '',
          status: '',
          items: [],
          note: '',
          datetime: '',
          ref: '',
          date: '',
          time: '',
          project_id: '',
          project_name: '',
          project_note: '',
          internal_bool: true,
          public_bool: false,
          can_deleted_bool: true,
          total_debit: 0,
          total_kredit: 0,
          reason: '',
          vendor_id: '',
          vendor_name: ''
        },
        vendor: [],
        setCoa: [],

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          form: false,
          detail: false,
        },
        message: {
          success: '',
          error: '',
          status: '',
          select: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
    },
    watch: {
      // 'filter.date': function (val) {
      //   this.fetch()
      // },
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
      // 'form.project_id': function (val) {
      //   this.form.project_name = this.project.filter(item => item.id === val)[0].name
      // }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.filter.date = this.tab === 0 ? '' : moment().format('YYYY-MM-DD')
      this.fetch()
      this.fetchData()
      // this.fetchDataTemplate()
      this.fetchProject()
      this.fetchDivisi()
    },
    methods: {
      toSelected (selected) {
        this.selected_divisi.map((item) => {
          if (item.id === selected.id) {
            item.category_selected.push({
              id: '',
              title: '',
              balance: 0
            })
          }
        })
      },
      async fetchVendor () {
        let params = {
          // limit: 100000000000
          pagination_bool: false,
          project_id: this.form.project_id
        }

        await get(`vendor/options`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.vendor = res.results.data
          }
        })
      },
      async fetchVendorEdit (form) {
        let params = {
          // limit: 100000000000
          pagination_bool: false,
          project_id: this.form.project_id
        }

        await get(`vendor/options`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.vendor = res.results.data
            this.form.vendor_id = form.vendor_id,
            this.form.vendor_name = form.vendor_name
          }
        })
      },
      changeVendor() {
        this.form.vendor_id = ''
        this.form.vendor_name = ''
        this.fetchVendor()
      },
      async fetchDivisi () {
        let params = {
          pagination_bool: false,
          'from': 'jurnal'
        }

        await get(`unit/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.divisi = []
            this.divisi_default = []
            res.results.data.map((item) => {
              this.divisi_default.push({
                ...item,
                category_selected: [
                  {
                    id: '',
                    title: '',
                    balance: 0,
                    selected_bool: true,
                    note: ''
                  }
                ]
              })
            })
            // this.divisi = res.results.data
            res.results.data.map((item) => {
              this.divisi.push({
                ...item,
                category_selected: [
                  {
                    id: '',
                    title: '',
                    balance: 0,
                    selected_bool: true,
                    note: ''
                  }
                ]
              })
            })
          }
        })
      },
      async fetchProject () {
        let params = {
          limit: 100000000000
        }

        await get(`project/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.project = res.results.data
          }
        })
      },
      addfilter() {
        this.dialog.filter = true
        
        this.filter.transaction =  this.selected_filter.transaction,
        this.filter.ref =  this.selected_filter.ref,
        this.filter.project_name =  this.selected_filter.project_name
        this.filter.posisi =  this.selected_filter.posisi
      },
      toFilter() {
        this.filter.project_name = this.filter.project_name === '' || this.filter.project_name === null ? '' : this.filter.project_name
        this.filter.ref = this.filter.ref === '' || this.filter.ref === null ? '' : this.filter.ref
        this.filter.transaction = this.filter.transaction === '' || this.filter.transaction === null ? '' : this.filter.transaction
        this.selected_filter.transaction = this.filter.transaction
        this.selected_filter.ref = this.filter.ref
        this.selected_filter.project_name = this.filter.project_name
        this.selected_filter.posisi = this.filter.posisi
        this.dialog.filter = false

        let pagination = { row: this.limit, page: 1 }
        this.fetch(pagination)
      },
      toUpdateJurnal() {
        this.template.edit = true; 
        this.jurnal_update = [
          {
            selected: [],
            id: this.template.id,
            name: this.template.name
          }
        ]; 
        this.template.selected.map((item) => {
          this.jurnal_update[0].selected.push({
            ...item,
            debit: item.debit,
            kredit: item.kredit
          })
        })
      },
      addJurnalformTemplate() {
        // if (this.$refs.form) this.$refs.form.reset()
        this.message.success = ''
        this.message.error = ''
        this.dialog.template = false
        this.dialog.form = true
        this.form.items = []
        this.template.selected.map((item) => {
          this.form.items.push(item)
        })
        this.add_total_debit = 0
        this.add_total_kredit = 0
        this.form.items.map((item) => {
          this.add_total_debit += item.debit
          this.add_total_kredit += item.kredit
        })
      },
      addDetailTemplate () {
        this.template.selected = []
        this.template.list.map((item) => {
          if(item.id === this.template.id) {
            this.template.name = item.name
            item.data_array.map((item) => {
              this.template.selected.push({ 
                ...item,
                debit: item.debit*1,
                kredit: item.kredit*1
              })
            })
            // this.template.selected = item.data_array
          }
        }
        )
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        // if(this.filter.date === '' && this.tab === 1) {
        //   this.filter.date = moment().format('YYYY-MM-DD')
        // }
        this.paginationList = pagination
        // if (this.tab === 0) {
        //   this.filter.date = ''
        // }
        this.process.load = true

        this.limit = pagination.row
        let non_pagi = {
          // limit: 500
          pagination_bool: false,
          // datetime: this.filter.date,
        }

        let params = non_pagi

        let url = 'jurnal/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.item_jurnal = res.results.data

          //   this.lastIndex = (pagination.page - 1) * pagination.row 
          //   this.lastIndex += 1

          //   this.addFreezes()

          //   this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

          //   if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      async fetchDataTemplate (id) {
        let params = {
          // limit: 100000
          pagination_bool: false
          // year: moment().format('YYYY')
        }
        
        await get('jurnal/template/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.template.list = res.results.data
            res.results.data.map((item) => {
              if(item.id === id) {
                this.template.name = item.name
                this.template.selected = item.data_array
              }
            })

            // this.menu = res.results.data.map(item => {
            //   return {
            //     menu: false
            //   }
            // })

            // this.modalTime = res.results.data.map((item, index) => {
            //   return {
            //     menu: false,
            //     reft: `time${index}`
            //   }
            // })
          }
        })
      },

      async fetchData (data) {
        let params = {
          limit: 100000
          // year: moment().format('YYYY')
        }
        
        await get('jurnal/coa/options', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.setCoa = []
            this.item = []
            this.item_coa_jurnal  = []
            res.results.data.map((item) => {
              this.setCoa.push({ 
                kredit: 0,
                debit: 0,
                id: item.id,
                name: item.name,
                number: item.number
              })
              
            })

            // this.menu = res.results.data.map(item => {
            //   return {
            //     menu: false
            //   }
            // })

            // this.modalTime = res.results.data.map((item, index) => {
            //   return {
            //     menu: false,
            //     reft: `time${index}`
            //   }
            // })
          }
        })
      },
      changeTotal() {
        this.add_total_debit = 0
        this.add_total_kredit = 0
        this.form.items.map((item) => {
          this.add_total_debit += item.debit
          this.add_total_kredit += item.kredit
        })
      },
      // changeHarga(index) {
      //   this.form.items[index].supplier.map((supplier) => {
      //     if(supplier.supplier_id === this.form.items[index].supplier_id) {
      //       this.form.items[index].purchase_price = supplier.purchase_price
      //       this.changeTotal()
      //     }
      //   })
      // },

      reset () {
        if (this.$refs.titleJurnal) {this.$refs.titleJurnal.reset()}
        if (this.$refs.form) {this.$refs.form.reset()}
        this.selected_jurnal = {}

        // this.$refs.form.reset()
        this.add_total_debit = 0
        this.add_total_kredit = 0
        this.item = []
        this.item_coa_jurnal  = []
        this.setCoa.map((item) => {
          this.item.push({ 
            debit: 0,
            kredit: 0,
            id: item.id,
            name: item.name,
            number: item.number
          })
  
          this.item_coa_jurnal.push({ 
            debit: 0,
            kredit: 0,
            id: item.id,
            name: item.name,
            number: item.number
          })
        })

        this.divisi = []

        this.divisi_default.map((item) => {
          this.divisi.push({
            ...item,
            category_selected: [
              {
                id: '',
                title: '',
                balance: 0,
                selected_bool: true,
                note: ''
              }
            ]
          })
        })


        this.form = {
          // outlet_id: '',
          // location_id: '',

          date: moment().format('YYYY-MM-DD'),
          status: '',
          items: [],
          note: '',
          datetime: '',
          ref: '',
          // date: '',
          time: moment().format('HH:mm'),
          project_id: '',
          project_name: '',
          project_note: '',
          unit_array: [],
          public_bool: false,
          internal_bool: true
        }
        this.selected_divisi = []
        this.selected_coa = []

        this.process.form = false

        this.message.error = ''
      },

      resetDivisi () {
        this.selected_divisi = this.form.unit_array
      },
      saveDivisi () {
        this.form.unit_array = this.selected_divisi
        this.dialog.listDivisi = false
      },

      resetItem () {
        this.$refs.form.reset()
        this.add_total_debit = 0
        this.add_total_kredit = 0
        this.item = []
        this.item_coa_jurnal  = []
        this.setCoa.map((item) => {
          this.item.push({ 
            debit: 0,
            kredit: 0,
            id: item.id,
            name: item.name,
            number: item.number
          })
  
          this.item_coa_jurnal.push({ 
            debit: 0,
            kredit: 0,
            id: item.id,
            name: item.name,
            number: item.number
          })
        })
        if(this.dialog.form === true){

          this.selected_coa = this.form.items
        } else {

          this.selected_coa = this.jurnal_update[0].selected
        }
        // this.jurnal_update.selected = []
      },
      async fetchDetailJurnal () {
        this.process.detail = true
        let params = {
          // limit: 100000000000
          number: this.selected_jurnal.number
        }

        await get(`jurnal/manage/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.form = {
              // outlet_id: '',
              // location_id: '',

              date: moment(res.results.data.datetime).format('YYYY-MM-DD'),
              status: res.results.data.status,
              items: res.results.data.data_array,
              note: res.results.data.note,
              datetime: res.results.data.datetime,
              ref: res.results.data.ref,
              // date: '',
              time: moment(res.results.data.datetime).format('HH:mm'),
              project_id: res.results.data.project_id,
              project_name: res.results.data.project_name,
              project_note: res.results.data.project_note,
              unit_array: [],
              public_bool: res.results.data.public_bool,
              internal_bool: res.results.data.internal_bool,
              can_deleted_bool: res.results.data.can_deleted_bool,
              total_kredit: res.results.data.total_kredit,
              total_debit: res.results.data.total_debit,
              reason: res.results.data.reason,
              vendor_id: res.results.data.vendor_id,
              vendor_name: res.results.data.vendor_name
            }
            this.selected_coa = res.results.data.data_array
            this.selected_divisi = []
            this.divisi.map((item) => {
              res.results.data.unit_array.map((item_selected) => {
                if (item.id === item_selected.id) {
                  item.category_selected = item_selected.category_array
                  this.selected_divisi.push(
                    {
                      id: item.id,
                      name: item.name,
                      category_array: item.category_array,
                      category_selected: item_selected.category_array
                    }
                  )
                }
              })
            })
            this.form.unit_array = this.selected_divisi

            this.item.map((item) => {
              this.selected_coa.map((item_selected) => {
                if (item.id === item_selected.id) {
                  item.debit = item_selected.debit
                  item.kredit = item_selected.kredit
                }
              })
            })
            this.add_total_debit = res.results.data.total_debit
            this.add_total_kredit = res.results.data.total_kredit
            this.fetchVendorEdit(this.form)
            this.dialog.form = true
            this.process.detail = false
          }
        })
      },
      selectedJurnal () {
        if (this.$refs.titleJurnal) {this.$refs.titleJurnal.reset()}
        if (this.$refs.form) {this.$refs.form.reset()}

        // this.$refs.form.reset()
        this.message.select = ''
        this.add_total_debit = 0
        this.add_total_kredit = 0
        this.item = []
        this.item_coa_jurnal  = []
        this.setCoa.map((item) => {
          this.item.push({ 
            debit: 0,
            kredit: 0,
            id: item.id,
            name: item.name,
            number: item.number
          })
  
          this.item_coa_jurnal.push({ 
            debit: 0,
            kredit: 0,
            id: item.id,
            name: item.name,
            number: item.number
          })
        })

        this.divisi = []

        this.divisi_default.map((item) => {
          this.divisi.push({
            ...item,
            category_selected: [
              {
                id: '',
                title: '',
                balance: 0,
                selected_bool: true,
                note: ''
              }
            ]
          })
        })
        this.fetchDetailJurnal()


        this.process.form = false

        this.message.error = ''

      },
      saveItem () {
        this.form.items = this.selected_coa
        if(this.dialog.template) {
          this.jurnal_update[0].selected = this.selected_coa
        }
        this.dialog.listCoa = false
      },
      async addTemplate () {
        this.message.error = ''
        
        // const isValid = await this.$refs.form.validate()
        // console.log(isValid)
        // if (isValid) {
          this.dialog.titleJurnal = true
          this.title_jurnal = ''
        // }
      },
      async SaveJurnal () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`jurnal/template/add`, {
            data: {
              name: this.title_jurnal,
              data_array: this.form.items.map(item => {
              return {
                id: item.id,
                number: item.number,
                debit: item.debit,
                kredit: item.kredit,
                name: item.name,
              }
            })
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.titleJurnal = false
              this.template.selected = []
              this.template.id = ''
              this.template.name = ''
              this.template.form = []
              this.template.edit = false

              this.fetchDataTemplate()

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async updateTemplateJurnal () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`jurnal/template/update`, {
            data: {
              name: this.jurnal_update[0].name,
              id: this.template.id,
              data_array: this.jurnal_update[0].selected.map(item => {
              return {
                id: item.id,
                number: item.number,
                debit: item.debit,
                kredit: item.kredit,
                name: item.name,
              }
            })
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.template.edit = false
              this.fetchDataTemplate(this.template.id)

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        // console.log(isValid)
        // console.log(this.$refs.form.errors)
        if (isValid) {
          let posisi = this.form.internal_bool === false && this.form.public_bool === false ? false : true
          if (posisi) {
            this.process.form = true

            // SAVE TO REST API
            await post(`jurnal/manage/update`, {
              data: {
                number: this.selected_jurnal.number,
                datetime: `${this.form.date} ${this.form.time}:00`,
                type: 'jurnal umum',
                ref: this.form.ref,
                note: this.form.note,
                project_id: this.form.project_id,
                project_name: this.form.project_name,
                project_note: this.form.project_note,
                internal_bool: this.form.internal_bool,
                public_bool: this.form.public_bool,
                data_array: this.form.items.map(item => {
                  return {
                    id: item.id,
                    number: item.number,
                    debit: item.debit,
                    kredit: item.kredit,
                    name: item.name,
                  }
                }),
                unit_array: this.form.unit_array.length > 0 ? this.form.unit_array.map(item => {
                  return {
                    id: item.id,
                    name: item.name,
                    category_array: item.category_selected
                  }
                }) : [],
                total_debit: this.add_total_debit,
                total_kredit: this.add_total_kredit,
                reason: this.form.reason,
                can_deleted_bool: this.form.can_deleted_bool,
                vendor_id: this.form.vendor_id,
                vendor_name: this.form.vendor_name
              }
            })
            .then((response) => {
              let res = response.data

              this.process.form = false

              if (res.status === 200) {

                this.reset()
                this.dialog.form = false
                this.dialog.success = true
                this.message.success = res.message
                this.fetch()
                this.fetchDivisi()

              } else {
                this.message.error = res.message
              }
            })
          }
          else {
            this.message.error = 'Harap pilih salah satu atau keduanya untuk jurnal internal atau jurnal public'
          }
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async saveStatus () {
        this.message.error = ''

          this.process.form = true
          let url = this.message.status === 'terima' ? 'jurnal/verification/approve' : 'jurnal/verification/reject'

          // SAVE TO REST API
          await post(`${url}`, {
            data: {
              number: this.selected_list.toString()
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.reset()
              this.verifikasi_add = res
              if(this.message.status === 'terima') {
              this.dialog.addvarifikasi = true
              } else {
                this.dialog.snackbar = true
                this.message.success = res.message
              }
              this.dialog.status = false
              this.selected_list = []
              this.fetch()
              this.message.status = ''

            } else {
              this.message.error = res.message
            }
          })
          
        },
      toDeleteJurnal () {
        this.dialog.delete = true
        this.message.error = ''
        this.message.success = ''
        this.process.delete = false
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`jurnal/manage/delete`, {
          data: {
            // id: this.template.id
            number: this.selected_jurnal.number
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false
            this.reset()
            this.dialog.success = true
            this.message.success = res.message
            this.fetch()
            this.fetchDivisi()
            
            this.template.selected = []
            this.template.id = ''
            this.template.name = ''
            this.template.form = []
            this.template.edit = false
            
            this.dialog.delete = false
            this.dialog.form = false

            // this.fetchDataTemplate()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>


<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper-jurnal { 
  overflow-y: auto; 
  height: calc(100vh - 360px);
} 
.wrapper-jurnal th { 
  position: sticky; 
  top: 0; 
} 
.wrapper_add { 
  overflow-y: auto; 
  ; 
} 
.wrapper_add th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
}
.wrapper_jurnal {
  overflow-y: auto; 
  height: calc(100vh - 450px); 
}
.wrapper_jurnal th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
}
tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>